<template>
    <div class="testimonial-view" v-loading="loading">
        <div class="row">

            <div class="col-md-4 mb-2">
                <el-button type="primary" @click="blukDelete" v-if="rights.delete">Bulk Delete</el-button>
                <el-button type="primary" @click="page.openDialog = true" v-if="rights.add">Add Special Program</el-button>

                <el-dialog
                    title="Special Program"
                    :visible.sync="page.openDialog"
                    width="90%"
                    :before-close="handleDialogClose"
                    v-loading="page.dialogLoding">
                    <span>
                        <div class="row">
                            <div class="col-md-12 mb-2">

                                <el-form ref="courseForm" :model="page.form" :rules="page.formRules" label-width="150px">

                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Image" prop="image">
                                                <div class="uploadDrag">
                                                    <input
                                                        type="file"
                                                        id="fileUpload"
                                                        ref="file"
                                                        name="file"
                                                        class="c-input u-sb-small"
                                                        @change="handleChange()">
                                                    <p id="fileUploadText">{{page.fileSelect}}</p>
                                                </div>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6 img-select" v-if="page.fileData != null">
                                            <div class="" style="width:100%; height:200px;">
                                                <img :src="page.fileData" class="selected-img">
                                                <div class="middle">
                                                    <div class="text" @click="handleRemove">Remove</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <el-form-item label="Name" prop="name">
                                        <el-input v-model="page.form.name" ref="name"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Description" prop="description">
                                        <vue-editor v-model="page.form.description" :editorToolbar="customToolbar" ref="description"></vue-editor>
                                    </el-form-item>

                                    <el-form-item label="Eligibility" prop="eligibility">
                                        <vue-editor v-model="page.form.eligibility" :editorToolbar="customToolbar" ref="eligibility"></vue-editor>
                                    </el-form-item>

                                    <el-form-item label="Fees" prop="fees">
                                        <el-input v-model="page.form.fees" ref="fees" oninput="this.value=this.value.replace(/[^\d\.]/,'')"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Duration" prop="duration">
                                        <el-input v-model="page.form.duration" ref="duration" oninput="this.value=this.value.replace(/[^\d\.]/,'')"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Duration In">
                                        <el-radio v-model="page.form.duration_in" label="Days">Days</el-radio>
                                        <el-radio v-model="page.form.duration_in" label="Weeks">Weeks</el-radio>
                                        <el-radio v-model="page.form.duration_in" label="Months">Months</el-radio>
                                        <el-radio v-model="page.form.duration_in" label="Years">Years</el-radio>
                                    </el-form-item>

                                    <el-form-item label="no. Of Semester" prop="no_of_semester">
                                        <el-input v-model="page.form.no_of_semester" ref="no_of_semester" oninput="this.value=this.value.replace(/[^\d]/,'')"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Affilated To" prop="affilated_to">
                                        <el-input v-model="page.form.affilated_to" ref="affilated_to"></el-input>
                                    </el-form-item>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Document" prop="document">
                                                <div class="uploadDrag">
                                                    <input
                                                        type="file"
                                                        id="fileUpload"
                                                        ref="document"
                                                        name="document"
                                                        class="c-input u-sb-small"
                                                        @change="handleDocumentChange()">
                                                    <p id="fileUploadText">{{page.documentSelect}}</p>
                                                </div>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6 img-select" v-if="page.documentData != null">
                                            <div class="" style="width:100%; height:200px;">
                                                <iframe :src="page.documentData" frameborder="0" style="width:100%; height:100%"></iframe>
                                            </div>
                                        </div>

                                    </div>

                                    <el-form-item>
                                        <el-button type="primary" @click="submitData" v-if="page.formBtnSubmit">Submit</el-button>
                                        <el-button type="primary" @click="resetData('courseForm')" v-if="page.formBtnSubmit">Reset</el-button>
                                        <el-button type="primary" @click="updateData" v-if="page.formBtnUpdate">Update</el-button>
                                    </el-form-item>

                                </el-form>

                            </div>
                        </div>

                    </span>
                </el-dialog>
            </div>

            <div class="col-md-4 mb-2">
            </div>

            <div class="col-md-4 mb-2">
                <el-input v-model="table.search" placeholder="Search By Name" v-if="rights.view" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-2">
                <el-table
                    :data="table.tableData.filter(data => !table.search || data.name.toLowerCase().includes(table.search.toLowerCase()))"
                    :default-sort = "{prop: 'name', order: 'descending'}"
                    style="width: 100%"
                    v-loading="table.loading"
                    @selection-change="handleSelectionChange"
                    v-if="rights.view">

                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <h4>Description: </h4>
                                <p v-html="props.row.description"></p>
                            <hr>
                            <h4>Eligibility: </h4>
                                <p v-html="props.row.eligibility"></p>
                            <hr>
                            <h4>Document: </h4>
                                <p v-if="props.row.document != '' "><a :href="props.row.document_path" target="_blank">{{props.row.document}}</a></p>

                                <p v-if="props.row.document == ''"> Document Not Found !!!</p>
                        </template>
                    </el-table-column>

                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>

                    <el-table-column label="Image" min-width="50"> 
                        <div slot-scope="{row}">
                            <img :src="row.image_path" alt="" style="width:100px;">
                        </div>
                    </el-table-column>
                    <el-table-column label="Name" prop="name" sortable> </el-table-column>
                    <el-table-column label="Fees" :formatter="feesFormatter"> </el-table-column>
                    <el-table-column label="Duration" :formatter="durationFormatter"> </el-table-column>
                    <el-table-column label="No. Of Semester" :formatter="semesterFormatter"> </el-table-column>
                    <el-table-column label="Affilated To" :formatter="affilatedFormatter"> </el-table-column>

                    
                    

                    <el-table-column
                        v-if="rights.edit || rights.delete"
                        align="right">
                        <template slot="header">
                            Action
                        </template>
                        <template slot-scope="scope">
                            <el-button
                            v-if="rights.edit"
                            size="mini"
                            @click="handleEditClick(scope.$index, scope.row)">Edit</el-button>
                            <el-button
                            v-if="rights.delete"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="row" v-if="rights.view">
            <div class="col-md-12">
                <div class="block" style="text-align:center">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="[100, 200, 500]"
                    :page-size="pagination.perPageItem"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.totalData">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {generateHeader, handleFileType, handleFileSize} from "@/misc/function.js";
import { VueEditor } from "vue2-editor";
export default {
    components: {
        VueEditor
    },
    data () {

        const validName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the name'))
            } else {
                callback()
            }
        }
        const validDescription = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Description'))
            } else {
                callback()
            }
        }
        const validEligibility = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Plase fill the Eligibility'))
            } else {
                callback()
            }
        }

        const validFees = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Plase fill the Fees'))
            } else {
                callback()
            }
        }

        const validDuration = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Plase fill the Duration'))
            } else {
                callback()
            }
        }

        const validSemester = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Plase fill the Semester'))
            } else {
                callback()
            }
        }

        const validAffilated = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Plase fill the Affilated'))
            } else {
                callback()
            }
        }

        const validImage = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please Select File'))
            } else {
                callback()
            }
        }
        
        const validDocument = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please Select File'))
            } else {
                callback()
            }
        }

        return {
            formatter: (row, col, value, index) => {
                return row.popular == 1 ? "Yes" : "No"
            },
            durationFormatter: (row, col, value, index) => {
                return row.duration == 0 ? " - " : row.duration + " " + row.duration_in
            },
            semesterFormatter: (row, col, value, index) => {
                return row.no_of_semester == 0 ? " - " : row.no_of_semester
            },
            affilatedFormatter: (row, col, value, index) => {
                return row.affilated_to == '' ? " - " : row.affilated_to
            },
            feesFormatter: (row, col, value, index) => {
                return row.fees == 0 ? " - " : row.fees
            },
            loading: false,
            fileError: false,
            documentError: false,
            customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
            rights: {
                page: true,
                view: false,
                add: false,
                edit: false,
                delete: false,
                bulk_delete: false,

            },
            page: {
                openDialog: false,
                dialogLoding: false,
                fileSelect: 'Drag your files here or click in this area.',
                documentSelect: 'Drag your files here or click in this area.',
                fileData: null,
                documentData: null,
                duration_in: 'Days',
                form: {
                    sp_id: 0,
                    name: '',
                    description: '',
                    eligibility: '',
                    fees: '',
                    duration: '',
                    duration_in: 'Days',
                    no_of_semester: '',
                    affilated_to:'',
                    image: '',
                    document: '',
                    popular: false
                },
                formRules: {
                    name: [{ required: true, trigger: 'blur', validator: validName }],
                    description: [{ required: true, trigger: 'blur', validator: validDescription }],
                    eligibility: [{ required: true, trigger: 'blur', validator: validEligibility }],
                    image: [{ required: true, trigger: 'blur', validator: validImage }]
                },
                formBtnSubmit: true,
                formBtnUpdate: false,
                formValid: false
            },
            table: {
                search: '',
                loading: false,
                multipleSelection: [],
                tableData: []
            },
            pagination: {
                currentPage: 1,
                perPageItem: 100,
                totalData: 0
            }
        }
    },
    methods: {
        // Image Change 
        handleChange() {
            this.page.form.image = this.$refs.file.files[0]
            if(handleFileSize(1393750 , this.page.form.image.size) == "false"){
                this.fileError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Size Too Large. Please Upload less then 1MB File !!!"
                });
            }
            var allowed_type = ['image/png' , 'image/jpg' , 'image/jpeg']
            if(handleFileType(allowed_type , this.page.form.image.type) == "false"){
                this.fileError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Type Invalid. Please Upload Only png , jpg or jpeg type !!!"
                });
            }
            
            if(!this.fileError){

                this.page.fileSelect = "File Selected"
                const input = this.$refs.file
                const files = input.files
                if (files && files[0]) {
                    const reader = new FileReader
                    reader.onload = e => {
                        this.page.fileData = e.target.result
                    }
                    reader.readAsDataURL(files[0])
                    this.$emit('input', files[0])
                }
            }
            else{
                this.page.form.image = ""
                this.fileError = false
            }
        },
        // Document Change 
        handleDocumentChange() {
            this.page.form.document = this.$refs.document.files[0]
            if(handleFileSize(10000000 , this.page.form.document.size) == "false"){
                this.documentError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Size Too Large. Please Upload less then 10MB File !!!"
                });
            }
            var allowed_type = ['application/pdf']
            if(handleFileType(allowed_type , this.page.form.document.type) == "false"){
                this.documentError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Type Invalid. Please Upload Only PDF Document !!!"
                });
            }
            
            if(!this.documentError){

                this.page.documentSelect = "File Selected"
                const input = this.$refs.document
                const files = input.files
                if (files && files[0]) {
                    const reader = new FileReader
                    reader.onload = e => {
                        this.page.documentData = e.target.result
                    }
                    reader.readAsDataURL(files[0])
                    this.$emit('input', files[0])
                }
            }
            else{
                this.page.form.document = ""
                this.documentError = false
            }
        },
        handleRemove(){
            this.page.fileData = null,
            this.page.fileSelect = "Drag your files here or click in this area.",
            this.page.form.image = ''
        },
        //Dialog Close Event
        handleDialogClose(done) {
            this.$confirm('Are you sure to close this dialog?')
            .then(_ => {
                this.resetData('courseForm')
                done();
            })
            .catch(_ => {});
        },
        handleFormValid(formRef){
            this.$refs[formRef].validate((valid) => {
                if(valid){
                    this.page.formValid = true
                }
                else{
                    this.page.formValid = false
                }
            });
        },
        //Page Size
        handleSizeChange(val) {
            this.pagination.perPageItem = val
            this.getData()
        },
        //Current Page
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.getData()
        },
        //Multi Select
        handleSelectionChange(val){
            this.table.multipleSelection = val
        },
        //Single row Edit
        handleEditClick(index, row) {
            this.page.form.sp_id = row.sp_id
            this.page.form.name = row.name
            this.page.form.description = row.description
            this.page.form.eligibility = row.eligibility
            this.page.form.fees = row.fees
            this.page.form.duration = row.duration
            this.page.form.duration_in = row.duration_in
            this.page.form.no_of_semester = row.no_of_semester
            this.page.form.affilated_to = row.affilated_to
            this.page.form.popular = row.popular == 1 ? true : false
            this.page.form.image = row.image
            this.page.fileData = row.image_path
            this.page.form.document = row.document
            this.page.documentData = row.document_path
            
            

            this.page.formBtnSubmit = false
            this.page.formBtnUpdate = true

            this.page.openDialog = true
        },
        getRights() {
            this.loading = true
            this.$axios.post('special-program/rights.php' , {} , {
                headers: generateHeader("specialProgramRights")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    //Whole Page Right
                    this.rights.page = response.data.body.rights.special_program_page == 1 ? true : false
                    // Rights
                    this.rights.add = response.data.body.rights.special_program_add == 1 ? true : false
                    this.rights.view = response.data.body.rights.special_program_view == 1 ? true : false
                    this.rights.edit = response.data.body.rights.special_program_edit == 1 ? true : false
                    this.rights.delete = response.data.body.rights.special_program_delete == 1 ? true : false
                    this.rights.bulk_delete = response.data.body.rights.special_program_bulk_delete == 1 ? true : false

                    this.getData();
                }
                else if(response.data.code == "403"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    this.$router.push('/admin/dashboard')
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.loading = false
            })
        },
        getData() {
            this.table.loading = true
            this.$axios.post("special-program/get.php" , {
                pageSize: this.pagination.perPageItem,
                page: this.pagination.currentPage
            },{
                headers: generateHeader("specialProgramData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    this.table.tableData = response.data.body
                    this.pagination.totalData = parseInt(response.data.extra.totalData)
                }
                else if(response.data.code == "404"){
                    this.table.tableData = []
                    this.pagination.totalData = 0
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.table.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.table.loading = false
            })
        },
        submitData(){
            this.handleFormValid("courseForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                let formData = new FormData()
                formData.append('file', this.page.form.image)
                formData.append('document', this.page.form.document)
                formData.append('name', this.page.form.name)
                formData.append('description', this.page.form.description)
                formData.append('eligibility', this.page.form.eligibility)
                formData.append('fees', this.page.form.fees)
                formData.append('duration', this.page.form.duration)
                formData.append('duration_in', this.page.form.duration_in)
                formData.append('no_of_semester', this.page.form.no_of_semester)
                formData.append('affilated_to', this.page.form.affilated_to)
                if(this.page.form.popular){
                    formData.append('popular', 1)
                }
                else{
                    formData.append('popular', 0)
                }
                

                this.$axios.post("special-program/add.php",formData, {
                    headers: generateHeader("specialProgramAdd", true)
                })
                .then((response) => {
                    if(response.data.code == "201"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('courseForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                   
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
            
        },
        updateData() {
            this.handleFormValid("courseForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                let formData = new FormData()
                formData.append('sp_id', this.page.form.sp_id)
                formData.append('file', this.page.form.image)
                formData.append('document', this.page.form.document)
                formData.append('name', this.page.form.name)
                formData.append('description', this.page.form.description)
                formData.append('eligibility', this.page.form.eligibility)
                formData.append('fees', this.page.form.fees)
                formData.append('duration', this.page.form.duration)
                formData.append('duration_in', this.page.form.duration_in)
                formData.append('no_of_semester', this.page.form.no_of_semester)
                formData.append('affilated_to', this.page.form.affilated_to)
                if(this.page.form.popular){
                    formData.append('popular', 1)
                }
                else{
                    formData.append('popular', 0)
                }

                this.$axios.post("special-program/update.php", formData, {
                    headers: generateHeader("specialProgramEdit")
                })
                .then((response) => {
                    if(response.data.code == "204"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('courseForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                    
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
        },
        //Single row Delete
        handleDelete(index, row) {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {

                this.$axios.post('special-program/delete.php' , {
                    id: row.sp_id
                }, {
                    headers: generateHeader("specialProgramDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
            })
        },
        // Bluk Delete
        blukDelete() {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {

                this.$axios.post('special-program/bulk-delete.php' , {
                    data: this.table.multipleSelection
                }, {
                    headers: generateHeader("specialProgramBulkDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
                this.$notify.info({
                    title: 'Info',
                    message: "Delete Cancle !!!"
                });
            })
        },
        resetData(formName){
            this.page.form.sp_id= 0
            this.page.form.name= ''
            this.page.form.description= ''
            this.page.form.eligibility= ''
            this.page.form.fees= ''
            this.page.form.duration= ''
            this.page.form.duration_in= 'Days'
            this.page.form.no_of_semester= ''
            this.page.form.affilated_to=''
            this.page.form.image= ''
            this.page.form.document= ''
            this.page.form.popular= false
            
            this.page.fileData = null
            this.page.documentData = null

            this.page.formBtnSubmit = true
            this.page.formBtnUpdate = false
            this.page.formValid = false
        }
    },
    mounted() {
        this.getRights()
    }
}

</script>


<style>
    .uploadDrag{
        /* position: absolute; */
        width: 100%;
        height: 200px;
        border: 4px dashed #000;
    }
    #fileUpload{
        position: absolute;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        outline: none;
        opacity: 0;
    }
    #fileUploadText{
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 170px;
        color: #000;
        font-family: Arial;
    }

    .selected-img{
        max-width: 100%;
        max-height: 100%;
        display: block;
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;
    }

    .middle {
        /* transition: .5s ease; */
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;

        background: #000;
        padding: 10px;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
    }

    .img-select:hover .selected-img{
        opacity: 0.3;
    }

    .img-select:hover .middle{
        opacity: 1;
    }
</style>